<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="flex justify-content-between items-center">
        <h4>Apps</h4>
        <p-button label="Añadir app" (click)="addApp()" icon="pi pi-plus" onKeyPress="" />
      </div>
      <div class="grid">
        @for (app of (apps$ | async); track app.id) {
        <div class="col-12 lg:col-6">
          <apps-mobile [app]="app"></apps-mobile>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Crear App"
  [(visible)]="viewModal"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '30vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="content">
    <form class="p-fluid py-2" [formGroup]="form">
      <div class="field">
        <span class="p-float-label">
          <input id="name" type="text" pInputText formControlName="name" />
          <label for="inputtext">Nombre</label>
        </span>
        @if (nameIsInvalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>

      <div class="field">
        <span class="p-float-label">
          <input id="stripe_pub_key" type="text" pInputText formControlName="stripe_pub_key" />
          <label for="inputtext">Public key Stripe</label>
        </span>
        @if (stripePupkeyIsInvalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>
      <div class="field">
        <span class="p-float-label">
          <p-password
            formControlName="stripe_pv_key"
            id="stripe_pv_key"
            [toggleMask]="true"
            [feedback]="false"
          ></p-password>
          <label for="stripe_pv_key">Private key Stripe</label>
        </span>
        @if (stripePrivateKeyIsInvalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>
      <div class="field">
        <span class="p-float-label">
          <input id="jitsi_server_url" type="text" pInputText formControlName="jitsi_server_url" />
          <label for="jitsi_server_url">Jitsi server URL</label>
        </span>

        @if (jitsiServerUrlIsInvalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>
      <div class="field">
        <span class="p-float-label">
          <p-password
            formControlName="jitsi_api_key"
            id="jitsi_api_key"
            [toggleMask]="true"
            [feedback]="false"
          ></p-password>
          <label for="jitsi_api_key">Jitsi API key</label>
        </span>
        @if (jitsiApiKeyIsInvalid) {
        <small class="p-error">Campo requerido</small>
        }
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      [loading]="loading"
      icon="pi pi-check"
      label="Guardar"
      onKeyPress=""
      (click)="onSubmit()"
    />
  </ng-template>
</p-dialog>
